var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{attrs:{"fill-opacity":".35","cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"d":"M12 11a1 1 0 011 1v5a1 1 0 01-.883.993L12 18a1 1 0 01-1-1v-5a1 1 0 01.883-.993L12 11zm0-5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }